window.PimV2GalleryBehavior = {
  init() {
    addPromoBadgesToPDPGallery();
  },

  syncGalleryVisibility(idFilter) {
    const galleryItem = document.querySelectorAll('.thumbnail-list__item');

    galleryItem.forEach(function(element) {
      const idcolor = element.getAttribute('data-filter-color');
      const colorsArray = ['white', 'oak', 'graphite', 'espresso', 'brushed-stainless', 'weathered-gray'];

      if (colorsArray.includes(idcolor)) {
        if (idFilter == idcolor) {
          element.classList.remove('display-none');
        } else if ('video' == idcolor) {
          element.classList.remove('display-none');
        } else {
          if (!element.classList.contains('display-none')) {
            element.classList.add('display-none');
          }
        }
      } else {
        element.classList.remove('display-none');
      }
    });

    if (document.querySelector('.product__media-item')) {
      const normalGalleryItem = document.querySelectorAll('.product__media-item');

      normalGalleryItem.forEach(function(element) {
        const idcolor = element.getAttribute('data-filter-color');
        const colorsArray = ['white', 'oak', 'graphite', 'espresso', 'brushed-stainless', 'weathered-gray'];

        if (colorsArray.includes(idcolor)) {
          if (idFilter == idcolor) {
            element.classList.remove('display-none');
          } else if ('video' == idcolor) {
            element.classList.remove('display-none');
          } else {
            if (!element.classList.contains('display-none')) {
              element.classList.add('display-none');
            }
          }
        } else {
          element.classList.remove('display-none');
        }
      });
    }
  }
};
